const COFFRET_HANDLE = 'coffret-degustation-vin';
let isApplying = false;

function isQtyValide(q) {
  if (q === 3) return true;
  if (q >= 6 && q % 6 === 0) return true;
  return false;
}

function prochainePalier(q) {
  if (q < 3) return 3 - q;
  if (q > 3 && q < 6) return 6 - q;
  return 6 - (q % 6);
}

function isExempt(el) {
  const row = el.closest('.cart-item');
  if (!row) return false;
  const link = row.querySelector('a[href*="/products/"]');
  return link ? link.href.includes(COFFRET_HANDLE) : false;
}

function getCartState() {
  const form = document.querySelector('form#cart');
  if (!form) return null;
  let totalNonExempt = 0, totalExempt = 0;
  form.querySelectorAll('input[name="updates[]"]').forEach((el) => {
    const v = parseInt(el.value, 10);
    if (!Number.isFinite(v) || v <= 0) return;
    if (isExempt(el)) totalExempt += v;
    else totalNonExempt += v;
  });
  return { totalNonExempt, totalExempt };
}

function updateRetrait(state) {
  const checkbox = document.querySelector('#retrait-checkbox');
  const info = document.querySelector('#retrait-info');
  const montant = document.querySelector('#retrait-montant');
  const error = document.querySelector('#retrait-error');
  if (!checkbox || !info || !montant || !error) return;

  const total = state ? state.totalNonExempt : 0;
  const isValid = total > 0 && isQtyValide(total);
  const remise = total * 2;

  if (checkbox.checked) {
    if (isValid) {
      montant.textContent = remise + '€';
      info.style.display = 'block';
      error.style.display = 'none';
    } else {
      info.style.display = 'none';
      error.style.display = 'block';
    }
  } else {
    info.style.display = 'none';
    error.style.display = 'none';
  }
}

window.applyRule = function () {
  if (isApplying) return;
  isApplying = true;

  const state = getCartState();
  const mustBlock = state && state.totalNonExempt > 0 && !isQtyValide(state.totalNonExempt);

  const msg = document.querySelector('#cart-m6-message');
  const txt = document.querySelector('#cart-m6-text');
  if (msg && txt) {
    if (mustBlock) {
      const manquant = prochainePalier(state.totalNonExempt);
      txt.textContent = `Ajoutez encore ${manquant} bouteille${manquant > 1 ? 's' : ''} pour valider votre panier.`;
      msg.style.display = 'block';
    } else {
      msg.style.display = 'none';
    }
  }

  const checkoutBtn = document.querySelector('#main-cart-footer #checkout');
  if (checkoutBtn) {
    checkoutBtn.disabled = mustBlock;
    checkoutBtn.style.opacity = mustBlock ? '0.55' : '';
    checkoutBtn.style.cursor = mustBlock ? 'not-allowed' : '';
  }

  const dyn = document.querySelector(
    '#main-cart-footer .additional-checkout-buttons, #main-cart-footer .cart__dynamic-checkout-buttons'
  );
  if (dyn) dyn.style.display = mustBlock ? 'none' : '';

  const shopPay = document.querySelector(
    '#main-cart-footer [data-shop-pay-button], #main-cart-footer shopify-pay-button'
  );
  if (shopPay) shopPay.style.display = mustBlock ? 'none' : '';

  updateRetrait(state);
  setTimeout(() => { isApplying = false; }, 200);
}

function bindRetrait() {
  const checkbox = document.querySelector('#retrait-checkbox');
  if (!checkbox) return;

  checkbox.addEventListener('change', function () {
    updateRetrait(getCartState());

    if (!checkbox.checked) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: '' })
      });
    }
  });

  const checkoutBtn = document.querySelector('#main-cart-footer #checkout');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function (e) {
      e.preventDefault();
      const cb = document.querySelector('#retrait-checkbox');
      const state = getCartState();

      if (cb && cb.checked && state && isQtyValide(state.totalNonExempt)) {
        window.location.href = '/checkout?discount=RETRAIT';
      } else {
        window.location.href = '/checkout';
      }
    });
  }
}

function bind() {
  window.applyRule();
  bindRetrait();

  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches('input[name="updates[]"]')) {
      window.applyRule();
    }
  });

  document.addEventListener('cart:updated', window.applyRule);
  document.addEventListener('cart:refresh', window.applyRule);

  const footer = document.querySelector('#main-cart-footer');
  if (footer) {
    let debounceTimer;
    const obs = new MutationObserver(() => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => window.applyRule(), 150);
    });
    obs.observe(footer, { childList: true, subtree: true });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bind);
} else {
  bind();
}